import React from 'react';
import {Box, Typography} from '@mui/material';
import {ShowIfDebugWrapper} from '../../../../contexts/DebugProvider';
import {OpenInCuro} from '../../../../utils/getCuroURL';

interface ChoiceDebugProps {
  newPlanPotId?: string;
  id?: string;
  sameReview?: boolean;
  reccId?: string | null;
  curoId?: string;
  isSubplan?: boolean;
}

export const BuilderChoiceDebug: React.FC<ChoiceDebugProps> = ({
  newPlanPotId,
  id,
  sameReview,
  reccId,
  curoId,
  isSubplan,
}) => (
  <>
    <ShowIfDebugWrapper debugKey="forms">
      <Box display="flex" flexWrap="wrap">
        <Typography mr={3} className="plan-id">
          {newPlanPotId || id}
        </Typography>
        {sameReview ? (
          <Typography mr={3}>
            <b>Created in Same review</b>
          </Typography>
        ) : null}
        <Typography mr={3}>ovrOriginalId:{reccId || ''}</Typography>
        <Typography>
          <b>{isSubplan ? 'Subplan' : 'Parent'}</b>
        </Typography>
      </Box>
    </ShowIfDebugWrapper>
    <OpenInCuro curoId={curoId} curoType="plan" />
  </>
);
